// extracted by mini-css-extract-plugin
module.exports = {"root":"Body_root__3BZBz","body":"Body_body__2TV11"};